import React from "react";
import { Link } from "react-router-dom";
import { heroContent } from "../mock";
import { useModeContext } from "../contexts/ModeContext";

const Impressum = () => {
  const { activeMode } = useModeContext();
  const c = heroContent.colors;

  return (
    <main className={`min-h-screen ${activeMode === 0 ? "bg-white" : "bg-neutral-950"}`}>
      {/* Header Spacer */}
      <div className="h-20"></div>
      
      <div className="mx-auto max-w-4xl px-6 py-12">
        <nav aria-label="Breadcrumb" className="mb-8">
          <ol className={`flex items-center space-x-2 text-sm ${activeMode === 0 ? "text-neutral-600" : "text-neutral-400"}`}>
            <li>
              <Link to="/" className={`hover:${activeMode === 0 ? "text-neutral-900" : "text-neutral-200"} transition-colors`}>
                Startseite
              </Link>
            </li>
            <li aria-hidden="true">/</li>
            <li aria-current="page" className={activeMode === 0 ? "text-neutral-900" : "text-neutral-200"}>Impressum</li>
          </ol>
        </nav>

        <h1 className="text-3xl font-bold mb-8" style={{ color: c.heading }}>
          Impressum
        </h1>

        <div className={`prose prose-neutral max-w-none ${activeMode === 1 ? "prose-invert" : ""}`}>
          <section aria-labelledby="angaben-heading" className={`${activeMode === 1 ? "bg-neutral-900 text-neutral-200" : ""} p-4 rounded-lg mb-6`}>
            <h2 id="angaben-heading" className={`text-xl font-semibold mb-4 ${activeMode === 1 ? "text-neutral-100" : ""}`}>
              Angaben gemäß § 5 TMG
            </h2>
            <address className={`not-italic mb-6 ${activeMode === 1 ? "text-neutral-300" : ""}`}>
              <strong>Tom Oppenhäuser</strong><br />
              Im Andorf 12<br />
              56170 Bendorf<br />
              Deutschland
            </address>
          </section>

          <section aria-labelledby="kontakt-heading" className={`${activeMode === 1 ? "bg-neutral-900 text-neutral-200" : ""} p-4 rounded-lg mb-6`}>
            <h2 id="kontakt-heading" className={`text-xl font-semibold mb-4 ${activeMode === 1 ? "text-neutral-100" : ""}`}>
              Kontakt
            </h2>
            <p className={`mb-6 ${activeMode === 1 ? "text-neutral-300" : ""}`}>
              E-Mail: <a href="mailto:mail@tom-oppenhaeuser.com" className={`${activeMode === 1 ? "text-blue-400 hover:text-blue-300" : "text-blue-600 hover:text-blue-800"}`}>mail@tom-oppenhaeuser.com</a>
            </p>
          </section>

          <section aria-labelledby="umsatzsteuer-heading" className={`${activeMode === 1 ? "bg-neutral-900 text-neutral-200" : ""} p-4 rounded-lg mb-6`}>
            <h2 id="umsatzsteuer-heading" className={`text-xl font-semibold mb-4 ${activeMode === 1 ? "text-neutral-100" : ""}`}>
              Umsatzsteuer-ID
            </h2>
            <p className={`mb-6 ${activeMode === 1 ? "text-neutral-300" : ""}`}>
              Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:<br />
              <em>Auf Anfrage verfügbar</em>
            </p>
          </section>

          <section aria-labelledby="berufsbezeichnung-heading" className={`${activeMode === 1 ? "bg-neutral-900 text-neutral-200" : ""} p-4 rounded-lg mb-6`}>
            <h2 id="berufsbezeichnung-heading" className={`text-xl font-semibold mb-4 ${activeMode === 1 ? "text-neutral-100" : ""}`}>
              Berufsbezeichnung und berufsrechtliche Regelungen
            </h2>
            <div className={`mb-6 ${activeMode === 1 ? "text-neutral-300" : ""}`}>
              <p><strong>Berufsbezeichnung:</strong> Coach</p>
              <p><strong>Verliehen in:</strong> Deutschland</p>
            </div>
          </section>

          <section aria-labelledby="haftung-content-heading" className={`${activeMode === 1 ? "bg-neutral-900 text-neutral-200" : ""} p-4 rounded-lg mb-6`}>
            <h2 id="haftung-content-heading" className={`text-xl font-semibold mb-4 ${activeMode === 1 ? "text-neutral-100" : ""}`}>
              Haftung für Inhalte
            </h2>
            <p className={`mb-4 ${activeMode === 1 ? "text-neutral-300" : ""}`}>
              Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den 
              allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht 
              unter der Verpflichtung, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach 
              Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
            </p>
            <p className={`mb-6 ${activeMode === 1 ? "text-neutral-300" : ""}`}>
              Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen 
              Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt 
              der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden 
              Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
            </p>
          </section>

          <section aria-labelledby="haftung-links-heading" className={`${activeMode === 1 ? "bg-neutral-900 text-neutral-200" : ""} p-4 rounded-lg mb-6`}>
            <h2 id="haftung-links-heading" className={`text-xl font-semibold mb-4 ${activeMode === 1 ? "text-neutral-100" : ""}`}>
              Haftung für Links
            </h2>
            <p className={`mb-4 ${activeMode === 1 ? "text-neutral-300" : ""}`}>
              Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. 
              Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten 
              Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.
            </p>
            <p className={`mb-6 ${activeMode === 1 ? "text-neutral-300" : ""}`}>
              Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. 
              Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente inhaltliche 
              Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht 
              zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.
            </p>
          </section>

          <section aria-labelledby="urheberrecht-heading" className={`${activeMode === 1 ? "bg-neutral-900 text-neutral-200" : ""} p-4 rounded-lg mb-6`}>
            <h2 id="urheberrecht-heading" className={`text-xl font-semibold mb-4 ${activeMode === 1 ? "text-neutral-100" : ""}`}>
              Urheberrecht
            </h2>
            <p className={`mb-4 ${activeMode === 1 ? "text-neutral-300" : ""}`}>
              Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen 
              Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der 
              Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
            </p>
            <p className={`mb-6 ${activeMode === 1 ? "text-neutral-300" : ""}`}>
              Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet. 
              Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte 
              Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem 
              auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei 
              Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.
            </p>
          </section>

          <section aria-labelledby="streitschlichtung-heading" className={`${activeMode === 1 ? "bg-neutral-900 text-neutral-200" : ""} p-4 rounded-lg mb-6`}>
            <h2 id="streitschlichtung-heading" className={`text-xl font-semibold mb-4 ${activeMode === 1 ? "text-neutral-100" : ""}`}>
              Streitschlichtung
            </h2>
            <p className={`mb-6 ${activeMode === 1 ? "text-neutral-300" : ""}`}>
              Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: 
              <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer" 
                 className={`${activeMode === 1 ? "text-blue-400 hover:text-blue-300" : "text-blue-600 hover:text-blue-800"} ml-1`}>
                https://ec.europa.eu/consumers/odr/
              </a>.<br />
              Unsere E-Mail-Adresse finden Sie oben im Impressum.<br /><br />
              Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer 
              Verbraucherschlichtungsstelle teilzunehmen.
            </p>
          </section>
        </div>

        <div className={`mt-12 pt-8 border-t ${activeMode === 1 ? "border-neutral-800" : "border-neutral-200"}`}>
          <Link 
            to="/" 
            className={`inline-flex items-center ${activeMode === 1 ? "text-blue-400 hover:text-blue-300" : "text-blue-600 hover:text-blue-800"} transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 rounded`}
          >
            ← Zurück zur Startseite
          </Link>
        </div>
      </div>
    </main>
  );
};

export default Impressum;
